/**
 * Spickprofi Trust Badge - Modal Controller
 * Handles opening/closing of the guarantee modal
 */

(function() {
  'use strict';

  var modal = document.getElementById('spickprofi-guarantee-modal');
  if (!modal) return;

  // Move modal to body to avoid stacking context issues
  document.body.appendChild(modal);

  var openButtons = document.querySelectorAll('[data-open-guarantee-modal]');
  var closeButtons = modal.querySelectorAll('[data-close-guarantee-modal]');

  function openModal() {
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Open modal on button click
  openButtons.forEach(function(btn) {
    btn.addEventListener('click', openModal);
  });

  // Close modal on close button or overlay click
  closeButtons.forEach(function(btn) {
    btn.addEventListener('click', closeModal);
  });

  // Close modal on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
})();
